import React from 'react';
import { Heart, ExternalLink } from 'lucide-react';

const DonationCard = ({ 
  donationUrl, 
  donationQrImage, 
  suggestedAmounts = [], 
  isAvailable = false,
  showTitle = true,
  compact = false,
  className = ""
}) => {
  // Default suggested amounts if none provided
  const defaultAmounts = [
    { label: "Per opportunity posted", amount: "$10–$25" },
    { label: "Monthly recurring", amount: "$10/month" },
    { label: "Annual underwriting", amount: "$250/year" }
  ];
  
  const amounts = suggestedAmounts.length > 0 ? suggestedAmounts : defaultAmounts;

  const handleDonateClick = () => {
    if (donationUrl) {
      window.open(donationUrl, '_blank', 'noopener,noreferrer');
    }
  };

  if (compact) {
    return (
      <div className={`bg-gradient-to-br from-[#FBF4EA] to-white rounded-lg p-4 border-2 border-[#E9DDCF] ${className}`} data-testid="donation-card-compact">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#8B2E3C] rounded-full flex items-center justify-center shrink-0">
            <Heart className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-medium text-[#222222] text-sm">Support this tool</p>
            <p className="text-xs text-[#666666] truncate">Donations sustain hosting & upkeep</p>
          </div>
          {isAvailable ? (
            <button
              onClick={handleDonateClick}
              className="btn-primary py-2 px-4 text-sm flex items-center gap-2 shrink-0"
              data-testid="donate-button"
            >
              Donate
              <ExternalLink className="w-4 h-4" />
            </button>
          ) : (
            <span className="text-xs text-[#666666] italic">Coming soon</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`card ${className}`} data-testid="donation-card">
      {showTitle && (
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-[#8B2E3C] rounded-full flex items-center justify-center">
            <Heart className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-[#222222]">Support this tool</h3>
            <p className="text-sm text-[#666666]">Help keep Community Kindness Circle running</p>
          </div>
        </div>
      )}

      <div className="space-y-3 mb-4">
        <p className="text-sm text-[#666666]">
          Suggested donation levels:
        </p>
        <ul className="space-y-2">
          {amounts.map((item, index) => (
            <li key={`${item.label}-${item.amount}`} className="flex items-center justify-between text-sm bg-[#FBF4EA] rounded-lg px-3 py-2">
              <span className="text-[#666666]">{item.label}</span>
              <span className="font-medium text-[#8B2E3C]">{item.amount}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="text-sm text-[#666666] mb-4 space-y-2">
        <p>Donations sustain hosting, upkeep, and support.</p>
        <p>We'll share periodic updates on usage and community impact.</p>
      </div>

      {donationQrImage && (
        <div className="flex justify-center mb-4">
          <img 
            src={donationQrImage} 
            alt="Donation QR Code" 
            className="w-32 h-32 border-2 border-[#E9DDCF] rounded-lg"
          />
        </div>
      )}

      {isAvailable ? (
        <button
          onClick={handleDonateClick}
          className="btn-primary w-full flex items-center justify-center gap-2"
          data-testid="donate-button"
        >
          <Heart className="w-5 h-5" />
          Support the tool
          <ExternalLink className="w-4 h-4" />
        </button>
      ) : (
        <div className="text-center py-3 bg-[#FBF4EA] rounded-lg">
          <p className="text-sm text-[#666666] italic">Donation link coming soon</p>
        </div>
      )}
    </div>
  );
};

export default DonationCard;
